<div class="question-wrapper">
  <div class="question-container">
    <div class="question">
      <fastr-ui-streaming-text
        *ngIf="animateQuestion; else settledQuestion"
        [text]="question"></fastr-ui-streaming-text>
      <ng-template #settledQuestion>{{ question }}</ng-template>
    </div>
    <div class="answers">
      <ng-container *ngIf="options.length">
        <div
          class="answer"
          *ngFor="let option of options; let i = index"
          [class.selected]="isSelected(option)"
          (click)="toggleOption(option)">
          <div class="icon-circle badge">
            {{ i + 1 }}
          </div>
          <div class="answer-content">
            <div class="answer-label">
              {{ option.label }}
            </div>
            <div class="answer-description">
              {{ option.description }}
            </div>
          </div>
        </div>
      </ng-container>
      <fastr-ui-ai-chat-custom-value
        *ngIf="allowCustomValue"
        [(value)]="customValue"
        [placeholder]="customValuePlaceholder"
        [showVoiceIcon]="showVoiceIcon"
        (submitted)="submit()">
      </fastr-ui-ai-chat-custom-value>
    </div>
    <div class="answer-section"></div>
    <fastr-ui-ai-chat-actions
      [showSecondaryActions]="showSecondaryActions"
      [reviewAndSearchLabel]="reviewAndSearchLabel"
      [refineLabel]="refineLabel"
      [continueLabel]="continueLabel"
      [showBackAction]="showBackAction"
      [reviewAndSearchDisabled]="isReviewAndSearchDisabled()"
      [refineDisabled]="isRefineDisabled()"
      [continueDisabled]="!canSubmit()"
      (reviewAndSearch)="submitReviewAndSearch()"
      (refine)="submitRefine()"
      (backed)="submitBack()"
      (continued)="submit()">
    </fastr-ui-ai-chat-actions>
  </div>
</div>
